export { loanApplicationService } from "@/modules/client/loan-application/store/services/loan-application-service";
export { organizationDetailsReducer } from "@/modules/client/loan-application/store/reducers";

// Re-export all endpoint hooks
export {
  useGetOrganizationDetailsQuery,
  useSendApplicationMutation,
} from "@/modules/client/loan-application/store/services/endpoints";

